import ContentWrapper from 'components/Wrappers/ContentWrapper';
import { useSelector } from 'react-redux';
import PopulationHealthDashboard from './widgets/PopulationHealthDashboard';

const PopulationHealth = () => {
  const { en: { titles } } = useSelector((state) => state.i18n);

  return <ContentWrapper titleText={titles.populationHealth}>
    <PopulationHealthDashboard />
  </ContentWrapper>;
};

export default PopulationHealth;
